import moment from 'moment';

import { EmployeeSurveyResponse } from '../survey-response-selector';

import { csvExporter } from '../../../util/csv-exporter';

export const surveyExporter = (
  surveyResponses: Array<EmployeeSurveyResponse>,
  user: AuthenticatedUser,
  survey: Survey,
  surveySentTimes: { [employeeId: number]: string },
) => {
  const json2csvData = surveyResponses.map((resp) => ({
    name: resp.name,
    received: resp.firstResponseTime ? resp.firstResponseTime.format('MM/DD/YY') : null,
    response: resp.responses
      .map(({ answer, imageUrls }) => {
        let response = null;
        if (answer) {
          response = answer;
        }
        if (imageUrls) {
          if (response) {
            response = `${response}, image${imageUrls.length > 1 ? 's' : ''}: ${imageUrls.join(
              ', ',
            )}`;
          } else {
            response = `image${imageUrls.length > 1 ? 's' : ''}: ${imageUrls.join(', ')}`;
          }
        }
        return response;
      })
      .filter(Boolean)
      .join('\r\n'),
    sentAt: surveySentTimes[resp.employeeId],
  }));

  const fields = [
    {
      label: 'Employee',
      value: 'name',
    },
    {
      label: 'Response',
      value: 'response',
    },
    {
      label: 'Received',
      value: 'received',
    },
    {
      label: 'Survey Sent On',
      value: 'sentAt',
    },
  ];

  const header = `Team Engine Survey Export,
Exported On,${moment().format('MM/DD/YY')}
Exported By,${user.firstName} ${user.lastName}
Survey Question,"${survey.messageBody}"

`;

  const filename = `team_engine_survey_${survey.surveyId}_${moment().format('MM/DD/YY')}.csv`;

  return csvExporter(filename, fields, json2csvData, header);
};
